import React, { useState } from "react";
import { useMutation, useQuery } from "react-query";
import {
  destroyInvite,
  loadInvites,
  resendInvite,
} from "../../../queries/invite";
import ReactPaginate from "react-paginate";
import {
  removeItem,
  updateObjectInArray,
} from "../../../redux/reducers/helpers";
import { useErrorHandler } from "react-error-boundary";
import PropTypes from "prop-types";

const InvitesPage = ({ queryClient, toast }) => {
  const handleError = useErrorHandler();
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);

  const fetchInvite = async (page = 1) =>
    loadInvites(page)
      .then((data) => {
        setTotalPages(data?.meta?.total_pages || 0);
        setPage(data?.meta?.page || 1);
        return data.results;
      })
      .catch((error) => {
        handleError(error);
      });

  const {
    isLoading,
    isError,
    data: invites,
    isPreviousData,
  } = useQuery(
    ["invites", page],
    () =>
      fetchInvite(page).then((data) => {
        return data;
      }),
    {
      keepPreviousData: true,
    }
  );

  const deleteInvite = useMutation(async (invite) => {
    if (confirm(`Are you sure that you want to delete ?`)) {
      return destroyInvite(invite.id).then((data) => {
        queryClient.setQueryData(["invites", page], removeItem(invites, data));
      });
    }
  });
  const sendInvite = useMutation(async (invite) => {
    if (
      confirm(
        `Are you sure that you want to resend invitation for ${invite.email} ?`
      )
    ) {
      return resendInvite(invite.id).then((data) => {
        queryClient.setQueryData(
          ["invites", page],
          updateObjectInArray(invites, data)
        );
        toast({
          title: "Invitation has been send",
          body: invite.email,
        });
      });
    }
  });

  const handlePageClick = (e) => {
    if (!isPreviousData) {
      setPage(e.selected + 1);
    }
  };

  return (
    <div className="container">
      <div className="d-flex align-items-center mb-45">
        <h3 className="m-0">Invites</h3>
      </div>

      <table className="table-list text-small">
        <thead>
          <tr>
            <th>EMAIL</th>
            <th>STATUS</th>
            <th>INVITATION DATE</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {!isLoading && !isError && (
            <>
              {invites.map((invite) => (
                <tr key={invite.id}>
                  <td>
                    <h5 className="text-small m-0">{invite.email}</h5>
                  </td>
                  <td>
                    <a href="mailto:<?php echo $email; ?>">{invite.status}</a>
                  </td>
                  <td>
                    <a href="mailto:<?php echo $email; ?>">
                      {invite.invitationDate}
                    </a>
                  </td>
                  <td className="table-actions nowrap">
                    <a
                      className="btn-transparent btn-icon ml-n2 ml-md-0"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Resend invitation"
                      onClick={() =>
                        sendInvite.mutate({
                          id: invite.id,
                          email: invite.email,
                        })
                      }
                    >
                      <i className="icon-resend" />
                    </a>
                    <a
                      className="btn-transparent btn-icon"
                      data-tooltip="tooltip"
                      data-placement="top"
                      title="Delete"
                      data-toggle="modal"
                      data-target="#delete-modal"
                      onClick={() =>
                        deleteInvite.mutate({
                          id: invite.id,
                        })
                      }
                    >
                      <i className="icon-delete" />
                    </a>
                  </td>
                </tr>
              ))}
            </>
          )}
        </tbody>
      </table>

      {totalPages > 1 && !isLoading && (
        <ReactPaginate
          onPageChange={(e) => handlePageClick(e)}
          previousLabel={"<"}
          nextLabel={">"}
          breakLabel={"..."}
          pageCount={totalPages}
          pageRangeDisplayed={totalPages}
          marginPagesDisplayed={2}
          containerClassName={"pagination mt-45"}
          activeClassName={"active"}
          activeLinkClassName={"current"}
        />
      )}
    </div>
  );
};

InvitesPage.propTypes = {
  queryClient: PropTypes.object.isRequired,
  toast: PropTypes.func.isRequired,
};

export default InvitesPage;
